import { FlowTask } from "@/controllers/flow";

/**
 * 広告視聴（Rewarded）フローのタスク群。
 *
 * 前提:
 * - GPT（googletag）と remodal が利用可能
 * - `modalAdGame` / `modalAdGameCompleted` の remodal が存在
 */

/**
 * Rewarded枠を事前に準備するタスク。
 */
export class AdsPreloadTask extends FlowTask {
  constructor() {
    super();
    this.googletag = window.googletag || { cmd: [] };

    this.googletag.cmd.push(() => {
      const rewardedSlot = this.googletag.defineOutOfPageSlot(
        //テスト広告
        // "/22639388115/rewarded_web_example",
        //本番広告
        "/23311213052/CapcomTown_browser_game/browser_game_preroll",
        this.googletag.enums.OutOfPageFormat.REWARDED
      );

      rewardedSlot.addService(this.googletag.pubads());
      this.googletag.pubads().addEventListener("rewardedSlotGranted", () => {
        this.googletag.destroySlots([rewardedSlot]);
      });

      this.googletag.enableServices();
      this.googletag.display(rewardedSlot);
      this.googletag.pubads().refresh([rewardedSlot]);
    });
  }

  async flowProcess(done) {
    done();
  }
}

/**
 * 広告視聴開始の確認モーダルを表示するタスク。
 * - 視聴可能になるまで再生ボタンを disabled
 */
export class AdsConfirmTask extends FlowTask {
  constructor() {
    super();
    this.googletag = window.googletag || { cmd: [] };
    this.rejectAdsButtonElement = document.querySelector("#reject-ads-button");
    this.playAdsButtonElement = document.querySelector("#play-ads-button");
    this.modal = $("[data-remodal-id=modalAdGame]").remodal({
      hashTracking: false,
      closeOnEscape: false,
      closeOnOutsideClick: false,
      modifier: "remodal-ads-reward"
    });

    this.adsEvent = null;
    this.playAdsButtonElement.disabled = true;
    this.playAdsButtonElement.classList.add("is-disabled");

    this.googletag.cmd.push(() => {
      this.googletag.pubads().addEventListener("rewardedSlotReady", (event) => {
        this.adsEvent = event;
        this.playAdsButtonElement.disabled = false;
        this.playAdsButtonElement.classList.remove("is-disabled");
      });
    });
  }

  async flowProcess(done) {
    this.onReject = () => done(false);
    this.onPlay = () => {
      if (this.adsEvent) {
        this.adsEvent.makeRewardedVisible();
        done();
      }
    };

    this.rejectAdsButtonElement.addEventListener("click", this.onReject);
    this.playAdsButtonElement.addEventListener("click", this.onPlay);
    this.modal.open();
  }

  deinitialize() {
    this.rejectAdsButtonElement.removeEventListener("click", this.onReject);
    this.playAdsButtonElement.removeEventListener("click", this.onPlay);
    this.modal.close();
  }
}

/**
 * 視聴中/視聴完了イベントを監視するタスク。
 * - granted: URLハッシュの扱いを補正しつつフローを進める
 * - closed: リロード（視聴キャンセル等の復帰用）
 */
export class AdsWatchTask extends FlowTask {
  constructor() {
    super();
    this.googletag = window.googletag || { cmd: [] };
  }

  async flowProcess(done) {
    const wasHashInUrl = window.location.hash === "#goog_rewarded";

    const onAdsGranted = () => {
      if (wasHashInUrl) {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      } else {
        history.back();
      }
      done();
    };

    this.googletag.pubads().addEventListener("rewardedSlotClosed", () => location.reload());
    this.googletag.pubads().addEventListener("rewardedSlotGranted", onAdsGranted);
  }
}

/**
 * 視聴完了後のモーダルを表示して、ユーザー操作で次に進むタスク。
 */
export class AdsCompleteTask extends FlowTask {
  constructor() {
    super();
    this.grantAdsButtonElement = document.querySelector("#grant-ads-button");
    this.modalElement = $("[data-remodal-id=modalAdGameCompleted]");
    this.modal = this.modalElement.remodal({
      hashTracking: false,
      closeOnEscape: false,
      closeOnOutsideClick: false,
      modifier: "remodal-ads-reward-granted"
    });
  }

  async flowProcess(done) {
    this.onClick = () => this.modal.close();
    this.onGrant = () => done();

    this.grantAdsButtonElement.addEventListener("click", this.onClick);
    this.modalElement.on("closed", this.onGrant);
    this.modal.open();
  }

  deinitialize() {
    this.grantAdsButtonElement.removeEventListener("click", this.onClick);
    this.modalElement.off("closed", this.onGrant);
  }
}
